import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchTargetdemand } from './targetdemandAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: {},
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchTargetdemandDataWithFilters = createAsyncThunk(
  'targetdemand/fetchTargetdemandDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchTargetdemand({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const TargetdemandSlice = createSlice({
  name: 'targetdemand',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchTargetdemandDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTargetdemandDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data[action.payload?.results?.[0]?.vin || 0] = action.payload.results?.[0] || { currentSoc: 0, state: '', vin: '' }; // Store the fetched data
      })
      .addCase(fetchTargetdemandDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectTargetdemandData = (state) => state.targetdemand.data;
export const selectTargetdemandStatus = (state) => state.targetdemand.status;
export const selectTargetdemandError = (state) => state.targetdemand.error;

export default TargetdemandSlice.reducer;
